import CardRoot, { Props, Ref } from './Card'
import { forwardRef } from 'react'

export type { Props }
export { CardHeader } from './CardHeader'
export type { CardHeaderProps } from './CardHeader'

function Card(props: Props, ref?: Ref) {
  return <CardRoot {...props} ref={ref} />
}

export default forwardRef(Card)
